module.exports = __webpack_public_path__ + "media/assets/images/empty-logo-ed574615ff1d7f3436aea51188d9ae6e.svg";